var map = {
	"./atenaspay.webp": 3738,
	"./cakto.webp": 5654,
	"./cooud.webp": 2680,
	"./eagle.webp": 3826,
	"./jumpfy.webp": 7679,
	"./nexuspag.webp": 7999,
	"./nxgate.webp": 1051,
	"./oasyfy.webp": 7851,
	"./omegapay.webp": 841,
	"./pagou.webp": 3286,
	"./pushinpay.webp": 981,
	"./stripe.webp": 9971,
	"./syncpay.webp": 8777,
	"./wiinpay.webp": 4789,
	"./wiinpay_old.webp": 3375,
	"./xpag.webp": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4966;